var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OrganizationPreferences',{attrs:{"organizationId":_vm.organizationId}})
}
var staticRenderFns = []

export { render, staticRenderFns }